export default {
  backHome: "← Tilbage til Forsiden",
  articleNotFound: "Guiden blev ikke fundet.",
  moreGuides: "Udforsk flere originale købsguides om AllChinaBuy spreadsheetet.",
  browseGuides: "Gennemse alle guides",
  published: "Udgivet",
  updated: "Sidst opdateret",
  author: "Af AllChinaBuy Spreadsheet-teamet",
  readTime: "min læsning",

  title: "AllChinaBuy Spreadsheet: Den Komplette Købsguide",
  metaTitle: "AllChinaBuy Spreadsheet: Den Komplette Købsguide (2026)",
  metaDescription: "En komplet guide til AllChinaBuy spreadsheet — hvordan du finder produkter, vurderer sælgere, læser QC-fotos og vælger forsendelse. Originale, køberfokuserede tips til smartere shopping.",

  intro: "AllChinaBuy spreadsheet er blevet en populær måde for købere at organisere produktfund, sammenligne sælgere og følge kvalitetstjek, før de afgiver en ordre. Denne guide forklarer, hvad spreadsheetet er, hvordan du bruger det, og hvordan du undgår de mest almindelige fejl — så du kan handle med bedre information og mindre gætteri.",

  tocTitle: "Indholdsfortegnelse",

  sections: [
    {
      id: "what-is",
      heading: "Hvad er AllChinaBuy Spreadsheet?",
      body: [
        "AllChinaBuy spreadsheet er et struktureret dokument, der samler produktlinks, sælgerdetaljer, kvalitetstjek-noter (QC) og forsendelsesinformation i én enkelt oversigt. I stedet for at holde snesevis af browserfaner åbne, bruger købere spreadsheetet til at sammenligne varer side om side og spotte de mest pålidelige muligheder.",
        "Et typisk AllChinaBuy spreadsheet grupperer varer efter kategori — sko, hættetrøjer, t-shirts, jakker, tasker, tilbehør og mere — og tilføjer derefter kolonner for QC-status, sælgerpåldelighed, nyttige noter og seneste opdateringsdato. Denne struktur forvandler en rodet liste af links til en klar, filtrerbar ressource.",
      ],
    },
    {
      id: "how-to-use",
      heading: "Sådan bruger du Spreadsheetet",
      body: [
        "Start med at vælge en kategori, du er interesseret i, og scan derefter rækkerne for varer, der matcher din smag og dit budget. Vær opmærksom på QC-kolonnen — varer markeret som verificerede leveres normalt med bekræftede fotos og mål, mens umarkerede varer kræver ekstra research, før du forpligter dig.",
        "Brug sælgerkolonnen til at tjekke, om en sælger har konsekvente, pålidelige annoncer. Datoen for seneste opdatering betyder også noget: information ændrer sig hurtigt, så prioriter rækker, der blev opdateret for nylig.",
      ],
    },
    {
      id: "evaluate-sellers",
      heading: "Sådan vurderer du sælgere",
      body: [
        "En god sælger har typisk detaljerede produktfotos, præcise størrelsesskemaer og en historik med konsekvente annoncer. Når du sammenligner sælgere i AllChinaBuy spreadsheetet, så kig efter dem med klar QC-information og færre klager over størrelses- eller materialeforskelle.",
        "Stol ikke på en enkelt annonce. Krydstjek det samme produkt på tværs af kategorier, når det er muligt, og behandl manglende information som et signal til at stille spørgsmål frem for en grund til at springe varen over.",
      ],
    },
    {
      id: "qc-photos",
      heading: "At læse QC-fotos",
      body: [
        "QC-fotos er dit bedste værn mod overraskelser. Kig efter billeder, der viser det faktiske produkt, ikke kun studio-gengivelser — tjek syninger, logoer, mærker, farvenøjagtighed og mål. Et nyttigt QC-sæt inkluderer nærbilleder af detaljer, der er nemme at få galt.",
        "Når du gennemgår QC-fotos i forbindelse med AllChinaBuy spreadsheetet, så sammenlign dem med den oprindelige annonce. Hvis noget ser anderledes ud, så bed om afklaring før forsendelse.",
      ],
    },
    {
      id: "shipping",
      heading: "Forsendelse og omkostninger",
      body: [
        "Internationale forsendelsesomkostninger afhænger af destination, pakkens vægt og den forsendelseslinje, du vælger. Tungere varer som jakker og sko koster mere at sende, mens let tilbehør og t-shirts er billigere. Brug forsendelsesguiderne i spreadsheetet til at estimere omkostninger, før du bestiller.",
        "Leveringstiden varierer efter transportør og destination. Hurtigere linjer koster mere, men ankommer før; økonomilinjer sparer penge, men tager længere tid. Vælg ud fra, hvor hurtigt du har brug for varerne, og hvor meget du vil bruge.",
      ],
    },
    {
      id: "mistakes",
      heading: "Almindelige fejl at undgå",
      body: [
        "En af de mest almindelige fejl er at ignorere QC-information og bestille i blinde. En anden er at vælge den forkerte størrelse, fordi størrelsesskemaet blev sprunget over. Begge er nemme at undgå, når du bruger spreadsheetets noter og QC-felter konsekvent.",
        "At skynde sig at sende uden at gennemgå de endelige QC-fotos er også risikabelt. Tag dig tid til at bekræfte, at alt ser rigtigt ud — det er langt billigere end at opdage et problem, efter pakken allerede har forladt lageret.",
      ],
    },
  ],

  ctaTitle: "Klar til at gennemse de organiserede fund?",
  ctaDesc: "Fortsæt til hovedwebstedet for at udforske det fulde AllChinaBuy spreadsheet, organiseret efter kategori, med QC- og sælgerinformation.",
  ctaLabel: "Udforsk AllChinaBuy Spreadsheet",
  buyLabel: "Køb Nu",
  backLabel: "Tilbage til Ressourcecenteret",
};